import { useState } from 'react';
import { Input, Modal, InputField, Button } from '@ets/design-system';
import { FormattedMessage, useIntl } from 'react-intl';
import { closeModal } from 'App/ModalContext/utils';
import { useModalData } from 'App/ModalContext/ModalContext';
import { useDeleteMetadataMutation } from 'App/redux/MetadataApi';
import styles from './DeleteMetadataModal.module.scss';
import { toast } from 'utils/toast';

const DeleteMetadataModal = () => {
  const intl = useIntl();
  const [deleteMetadata, { isLoading }] = useDeleteMetadataMutation();
  const [confirmation, setConfirmation] = useState('');
  const data = useModalData('DeleteMetadataModal');
  const close = () => {
    closeModal('DeleteMetadataModal');
  };

  const submit = async () => {
    if (data) {
      const result = await deleteMetadata(data.id);
      if (!('error' in result)) {
        toast({
          variant: 'success',
          title: 'METADATA_DELETED',
          message: 'METADATA_SUCCESSFULLY_DELETED',
          messageValues: { name: data.name },
        });
      }
      close();
    }
  };

  if (data) {
    const disabled = confirmation !== data.name;
    return (
      <Modal open testId="delete-metadata" width="65rem" close={close}>
        <Modal.Header>
          <FormattedMessage id="DELETE_METADATA" />
        </Modal.Header>
        <Modal.Body>
          <div className={styles.warning}>
            <FormattedMessage
              id="DELETE_METADATA_WARNING"
              values={{
                name: data.name,
                b: (chunks) => <span style={{ fontWeight: 'bold' }}>{chunks}</span>,
              }}
            />
          </div>
          <InputField
            size="l"
            label={intl.formatMessage({ id: 'TO_CONFIRM_ACTION_ENTER_METADATA_NAME' })}
            testId="confirm-metadata-name-input"
            feedbackContent={
              confirmation !== '' && disabled
                ? intl.formatMessage({ id: 'METADATA_NAME_DOES_NOT_MATCH' })
                : undefined
            }
          >
            <Input
              size="l"
              testId="confirm-metadata"
              placeholder={intl.formatMessage({ id: 'ENTER_METADATA_NAME' })}
              value={confirmation}
              onChange={(e) => setConfirmation(e.target.value)}
              hasError={confirmation !== '' && disabled}
            />
          </InputField>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="standard" size="m" testId="delete-metadata-modal-cancel" onClick={close}>
            <FormattedMessage id="global.cancel" />
          </Button>
          <Button
            size="m"
            testId="delete-metadata-modal-submit"
            onClick={submit}
            variant="danger"
            disabled={disabled}
            loading={isLoading}
            style={{ margin: '0 0 0 1rem' }}
          >
            <FormattedMessage id="DELETE_METADATA" />
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
  return null;
};

export default DeleteMetadataModal;
